import { memo } from 'react';

import { ArchiveRestoreIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

export type WorkspaceAgentComposerArchivedSessionMessageProps = {
  headingId: string;
  isUnarchivePending: boolean;
  message: string;
  onUnarchiveClick: () => void;
  unarchiveCtaLabel: string;
};

export const WorkspaceAgentComposerArchivedSessionMessage = memo(
  ({
    headingId,
    isUnarchivePending,
    message,
    onUnarchiveClick,
    unarchiveCtaLabel,
  }: WorkspaceAgentComposerArchivedSessionMessageProps) => {
    return (
      <div className="flex w-full items-center justify-between gap-3">
        <h2 className="min-w-0 font-medium ads:text-metadata text-14 text-gray-10 leading-5" id={headingId}>
          {message}
        </h2>
        <Button
          appearance="filled"
          color="blue"
          data-testid="WORKSPACE_AGENT_COMPOSER_ARCHIVED_SESSION_UNARCHIVE"
          disabled={isUnarchivePending}
          onClick={onUnarchiveClick}
          prefix={<ArchiveRestoreIcon size="xs" />}
          size="small"
          type="button"
        >
          {unarchiveCtaLabel}
        </Button>
      </div>
    );
  },
);

WorkspaceAgentComposerArchivedSessionMessage.displayName = 'WorkspaceAgentComposerArchivedSessionMessage';
